import Vue from 'vue'
import Router from 'vue-router'
import { mapCommonRouter } from '@/pages/common'
import goodsRouter from './goods.js'
import coupon_routes from './coupon_routes.js'
import integral from './integral.js'
import activity from './activity.js'
import album from './album.js'
import trainCamp from './trainCamp.js'
import subVip from './subVip'
import baijiayun from './baijiayun.js'
import address from './address.js'
import learningReport from './learningReport.js'
import infinite from './infinite.js'
import order from './order.js'

import { route } from '@/utils/build'
import store from '../store/index.js'
import { bindUserReferrer } from '@/utils/bindUserReferrer'
import receive from './receive.js'
Vue.use(Router)

/**
 * 路由注册
 */

const vueRouter = new Router({
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition && to.meta.keepAlive) {
      return savedPosition
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  },
  routes: [
    ...mapCommonRouter,
    ...goodsRouter,
    ...coupon_routes,
    ...integral,
    ...activity,
    ...album,
    ...trainCamp,
    ...subVip,
    ...receive,
    ...baijiayun,
    ...address,
    ...learningReport,
    ...infinite,
    ...order,
    // home页面
    // route('/', 'home', null, { redirect: '/pay/0' }),
    // 1.1 导购页
    // route('/pay/:id', 'pay',
    //   resolve => require(['@/pages/payment/views/payment/pay'], resolve)
    // ),
    // 1.2 订单支付
    route('/confirm-order/:id', 'confirmOrder', resolve =>
      require(['@/pages/payment/views/payment/order/confirm-order'], resolve)
    ),
    route('/confirm-pay', 'confirmPay', resolve =>
      require(['@/pages/payment/views/payment/order/confirm-pay'], resolve)
    ),
    // 1.2.1 优惠券列表
    route('/coupons', 'coupons', resolve => require(['@/pages/payment/views/payment/coupons'], resolve)),

    // 1.3 地址列表
    route('/address/push', 'addressPush', resolve =>
      require(['@/pages/payment/views/payment/address/address-push'], resolve)
    ),
    // 1.3.1 填写地址
    route('/address', 'addressList', resolve =>
      require(['@/pages/payment/views/payment/address/address-list'], resolve)
    ),

    // 1.4.1 支付成功
    route('/success/:id', 'success', resolve =>
      require(['@/pages/payment/views/payment/order/pay-success.vue'], resolve)
    ),
    route('/yhxy', 'yhxy', resolve => require(['@/pages/payment/views/payment/order/yhxy.vue'], resolve)),
    // 逻辑 payment/order/confirm-order.vue 607
    // 分组实验 体验/训练营购买成功页面 5-9适用
    // route('/success/camp/:id', 'campSuccess', resolve =>
    //   require(['@/pages/payment/views/payment/order/pay-success-camp.vue'], resolve)
    // ),
    // // 分组实验 体验/训练营购买成功页面 userId尾号 0-4适用
    // route('/success/newcamp/:id', 'newCampSuccess', resolve =>
    //   require(['@/pages/payment/views/payment/order/pay-success-camp-new.vue'], resolve)
    // ),
    // 1.4.2 支付失败
    route('/fail/:id', 'fail', resolve => require(['@/pages/payment/views/payment/order/pay-fail.vue'], resolve)),
    // 会员介绍
    route('/vipIntroduce', 'vipIntroduce', resolve => require(['@/pages/payment/views/vipIntroduce/index'], resolve)),
    // 会员中心
    route('/vipcenter', 'vipcenter', resolve => require(['@/pages/payment/views/vipcenter/VipCenter'], resolve)),
    // 拉新
    route('/pullnew', 'pullnew', resolve => require(['@/pages/payment/views/pullnew/pullnew'], resolve)),
    route('/pullnew2023', 'pullnew2023', resolve => require(['@/pages/payment/views/pullnew/pullnew'], resolve)),
    // 拉新详情页面
    route('/pullnew/detail', 'pullnewdetail', resolve =>
      require(['@/pages/payment/views/pullnew/pullnew-detail'], resolve)
    )
  ]
})

vueRouter.afterEach((to, from) => {
  console.log(to.path)
  const bind = to.path.indexOf('good') >= 0 || to.path.indexOf('order') >= 0 || to.path.indexOf('album-list') >= 0
  if (bind) {
    bindUserReferrer(store, 'payment---vueRouter.afterEach')
  }
})

export default vueRouter
